import React from "react";
import "fontsource-roboto";
import ReactDOM from "react-dom";
import "./i18n";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "styling/theme";
import { LocaleProvider } from "context/LocaleContext";

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <LocaleProvider>
        <CssBaseline />
        <App />
      </LocaleProvider>
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
